/**
 * Parche temporal: Separa links concatenados por coma en un array de links individuales.
 * @todo Esta función debe ser eliminada una vez que el backend implemente el fix
 * para devolver los links como un array en lugar de un string concatenado.
 * 
 * @param linkString - String que puede contener uno o más links separados por coma
 * @returns Array de strings con los links separados, sin espacios y sin valores vacíos
 */
export function splitLinksByComma(linkString: string): string[] {
  if (!linkString) return [];
  
  const trimmed = linkString.trim();
  if (!trimmed) return [];
  
  return trimmed.includes(',')
    ? trimmed.split(',').map((link) => link.trim()).filter(Boolean)
    : [trimmed];
}

